import moment from 'moment'

export const Supplier = {
    id: '',
    name: '',
    provinceId: '',
    address: '',
    email: '',
    phone: '',
    cellPhone: '',
    fax: '',
    createdBy : '',
    updatedBy : '',
    createdAt : moment().format('YYYY-MM-DD'),
    updatedAt : moment().format('YYYY-MM-DD'),
}